/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_delate': {
    width: 16,
    height: 16,
    viewBox: '0 0 14 16',
    data: '<path pid="0" class="st0" d="M5.5 12.5c.3 0 .5-.2.5-.4V6.4c0-.2-.2-.4-.5-.4s-.5.2-.5.4v5.8c0 .2.2.3.5.3zM8.5 12.5c.3 0 .5-.2.5-.4V6.4c0-.2-.2-.4-.5-.4s-.5.2-.5.4v5.8c0 .2.2.3.5.3z"/><path pid="1" class="st0" d="M10.5 3V.5h-7V3H0v2h1.5v10.5h11V5H14V3h-3.5zm1 11.5h-9V5h9v9.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/icon_delate.js